import React, { useState, useEffect } from 'react';
import './Gallery.css';
import img1 from '../assets/Img1.jpg';
import img3 from '../assets/Img3.jpg';
import img4 from '../assets/Img4.jpg';
// import img5 from '../assets/Img5.jpg';
// import img48 from '../assets/Img48.jpg'; 

interface GalleryImage {
  src: string;
  alt: string;
}

const images: GalleryImage[] = [
  { src: img1, alt: 'Spiritual Zen garden design in Fremantle and Perth' },
  { src: img3, alt: 'Minimalist garden layout for meditation' },
  { src: img4, alt: 'Zen garden with natural elements in Fremantle and Perth' },
];

const Gallery: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState<'left' | 'right' | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 8000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const goToNext = () => {
    setDirection('right');
    setTimeout(() => setCurrentIndex((prev) => (prev + 1) % images.length), 0);
  };

  const goToPrev = () => {
    setDirection('left');
    setTimeout(() => setCurrentIndex((prev) => (prev - 1 + images.length) % images.length), 0);
  };

  const goToImage = (index: number) => {
    setDirection(index > currentIndex ? 'right' : 'left');
    setTimeout(() => setCurrentIndex(index), 0);
  };

  useEffect(() => {
    if (direction) {
      const timer = setTimeout(() => setDirection(null), 500);
      return () => clearTimeout(timer);
    }
  }, [currentIndex, direction]);

  return (
    <section className="gallery">
      <div className="textbox">
        <h1 className="gallery-title">Image Gallery</h1>
      </div>
      <div className="textbox gallery-textbox">
        <div className="gallery-container">
          <button className="gallery-arrow gallery-arrow-left" onClick={goToPrev}>
            ‹
          </button>
          <div className="gallery-slider">
            <img
              key={currentIndex}
              src={images[currentIndex].src}
              alt={images[currentIndex].alt}
              className={`gallery-image ${direction ? `slide-${direction}` : ''}`}
              loading="lazy"
            />
          </div>
          <button className="gallery-arrow gallery-arrow-right" onClick={goToNext}>
            ›
          </button>
          <div className="gallery-bullets">
            {images.map((_, index) => (
              <span
                key={index}
                className={`gallery-bullet ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToImage(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;